import {useQuery} from '@tanstack/react-query';
import {userService} from '../services/user';

export function useCurrentUser() {
  return useQuery({
    queryKey: ['current-user'],
    queryFn: userService.getCurrentUser,
    staleTime: 0,
    cacheTime: 5 * 60 * 1000,
    refetchOnMount: true,
  });
}